import React from "react";
import Form from "react-bootstrap/esm/Form";
import { PickerOption } from "../../offering/picker";

interface PickerFormFieldProps {
  label?: string;
  name: string;
  value: string;
  placeholder?: string;
  error?: string | false;
  onChange: (value: string) => void;
  options: PickerOption[];
  onBlur?: React.FocusEventHandler<HTMLSelectElement>;
  errorRef?:
    | ((instance: HTMLElement | null) => void)
    | React.RefObject<HTMLElement>
    | null;
  selectRef?:
    | ((instance: HTMLSelectElement | null) => void)
    | React.RefObject<HTMLSelectElement>
    | null;
}

export function PickerFormField(props: PickerFormFieldProps) {
  const {
    label,
    placeholder,
    error,
    name,
    value,
    onChange,
    options,
    onBlur,
    errorRef,
    selectRef,
  } = props;

  return (
    <Form.Group controlId={name} className="picker-form-field-v2">
      <Form.Label className="picker-form-field-v2__label">{label}</Form.Label>
      <Form.Select
        className="picker-form-field-v2__input"
        aria-label={label}
        name={name}
        value={value}
        placeholder={placeholder}
        isInvalid={!!error}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        ref={selectRef}
      >
        <option disabled={!!placeholder} value="">
          {placeholder}
        </option>
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </option>
        ))}
      </Form.Select>
      {!!error && (
        <Form.Text className="text-danger" ref={errorRef}>
          {error}
        </Form.Text>
      )}
    </Form.Group>
  );
}
